import Button from "components/base/Button";
import { useContext } from "react";
import { v4 } from "uuid";
import { OrderContext } from "./OrderDetail";
import OrderLineView from "./OrderLineView";

const ProductsView = ({ odooPricelists }) => {
  const { originalOrder, order, setOrder, validStocks } =
    useContext(OrderContext);

  const availableProducts = validStocks.map((stock) => {
    return {
      ...stock.product,
      name: `[${stock.product.number}] ${stock.product.name}`,
      stock,
    };
  });

  function addLine() {
    setOrder((prev) => ({
      ...prev,
      orderLines: [
        ...prev.orderLines,
        {
          id: `new-${v4()}`,
          isNew: true,
          product: null,
          qty: 1,
          salesPrice: 0,
          discountPercentage: 0,
        },
      ],
    }));
  }

  function handleLineSelectorBlur(lineId) {
    setTimeout(() => {
      setOrder((prev) => {
        const line = prev.orderLines.find((i) => i.id === lineId);
        if (!line) return prev;
        if (line.product?.id || line.productId) return prev;
        return {
          ...prev,
          orderLines: prev.orderLines.filter((i) => i.id !== lineId),
        };
      });
    }, 0);
  }

  const odooPricelist = odooPricelists.find(
    (i) => i.id === order.odooPricelistId,
  );
  const odooCurrency = odooPricelist ? odooPricelist.currency : null;

  console.log("order.orderLines", order.orderLines);

  return (
    <div className="card">
      <h5>Products</h5>
      {originalOrder.stockCategory ? (
        <div className="mt-2 -mx-2">
          <table>
            <thead className="whitespace-nowrap">
              <tr>
                <th>Item</th>
                <th className="text-right">Stock</th>
                <th className="text-right">Qty</th>
                <th className="text-right">Sales Price</th>
                <th className="text-right">Discount %</th>
                <th className="text-right">Subtotal</th>
                {odooCurrency && (
                  <>
                    <th className="text-right">Sales Price({odooCurrency})</th>
                    <th className="text-right">Subtotal({odooCurrency})</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {order.orderLines.map((line) => (
                <OrderLineView
                  line={line}
                  key={line.id}
                  availableProducts={availableProducts}
                  odooCurrency={odooCurrency}
                  autoFocus={line.isNew && !line.product && !line.productId}
                  onLineSelectorBlur={() => handleLineSelectorBlur(line.id)}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <Button onClick={addLine}>+ Add Product</Button>
                </td>
                <td></td>
                <td className="text-right">
                  {order.orderLines.reduce(
                    (acc, line) => acc + parseInt(line.qty),
                    0,
                  )}
                </td>
                <td></td>
                <td></td>
                <td className="text-right">
                  {order.orderLines
                    .reduce(
                      (acc, line) =>
                        acc +
                        parseInt(line.qty) *
                          parseFloat(line.salesPrice) *
                          ((100 - parseFloat(line.discountPercentage)) / 100),
                      0,
                    )
                    .toFixed(2)}
                </td>
                {odooCurrency && (
                  <>
                    <td></td>
                    <td className="text-right">
                      {order.orderLines
                        .reduce(
                          (acc, line) =>
                            acc +
                            parseInt(line.qty) *
                              parseFloat(line.salesPrice) *
                              ((100 - parseFloat(line.discountPercentage)) /
                                100) *
                              order.exchangeRate,
                          0,
                        )
                        .toFixed(2)}
                    </td>
                  </>
                )}
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <div className="mt-2 opacity-70">
          Choose a stock category to add products.
        </div>
      )}
    </div>
  );
};

export default ProductsView;
